import React from 'react';
import {Routes} from "../constants";
import SignInView from "./sign_in_view";
import * as firebase from "firebase";
import PasswordReset from "./password_reset_view";

class SignIn extends React.Component {
    constructor(props) {
        super(props);
        let currentUser = firebase.auth().currentUser;
        let verify = false;
        if (currentUser != null) {
            // verify = !currentUser.emailVerified;
            console.log(verify);
        }
        this.state = {
            email: '',
            password: '',
            invalid: false,
            verify: verify,
            resendAvailable: true,
            resetPassword: !!props.resetPassword
        }
    }

    handleSubmit(ev) {
        const e = ev.nativeEvent;
        let email = e.target[0].value;
        if (!email.includes('@')) {
            email += '@micreate.eu';
        }
        const pass = e.target[1].value;
        firebase
            .auth()
            .signInWithEmailAndPassword(email, pass)
            .then((user) => {
                if (this.props.onSignedIn != null)
                    this.props.onSignedIn(user);
            })
            .catch((error) => {
                console.log(error);
                this.setState({invalid: true});
            });
        this.setState({
            email: email,
            password: pass
        });
    }

    handlePasswordReset(ev) {
        const e = ev.nativeEvent;
        const email = e.target[0].value;
        console.log(email);
        firebase.auth().sendPasswordResetEmail(email).then(
            () => this.setState({
                passwordResetDone: true,
                passwordResetInvalid: false
            })
        ).catch(
            () => this.setState({
                passwordResetInvalid: true
            })
        );
    }

    render() {
        if (this.state.resetPassword) {
            return (
                <PasswordReset
                    onPasswordReset={(e) => this.handlePasswordReset(e)}
                    onSubmit={(e) => this.handleSubmit(e)} {...this.props} {...this.state} />
            );
        } else {
            return (
                <SignInView
                    resendMail={this.state.resendAvailable ? () => this.resendMail() : null}
                    onPasswordReset={() => this.props.history.push(Routes.resetPassword)}
                    onSubmit={(e) => this.handleSubmit(e)}
                    invalid={this.state.invalid}
                    verify={this.state.verify} {...this.props}/>
            );
        }
    }

    resendMail() {
        this.setState({
            resendAvailable: false,
        });
        firebase.auth().currentUser.sendEmailVerification();
    }
}

export default SignIn;
